var exports = {
  "Nr": "VoiceActivityCard.module__card___bXdhb1",
  "wu": "VoiceActivityCard.module__headerContextGroup___bXdhb1",
  "U1": "VoiceActivityCard.module__headerRow___bXdhb1",
  "LD": "VoiceActivityCard.module__headerLeft___bXdhb1",
  "mB": "VoiceActivityCard.module__activityLabel___bXdhb1",
  "l1": "VoiceActivityCard.module__streamingLabel___bXdhb1",
  "kf": "VoiceActivityCard.module__contextButton___bXdhb1",
  "kx": "VoiceActivityCard.module__contextChannelName___bXdhb1",
  "fd": "VoiceActivityCard.module__contextIcon___bXdhb1",
  "gE": "VoiceActivityCard.module__actionIcon___bXdhb1",
  "o_": "VoiceActivityCard.module__contextGuildIcon___bXdhb1",
  "pz": "VoiceActivityCard.module__contextChevron___bXdhb1",
  "mr": "VoiceActivityCard.module__contextDmAvatar___bXdhb1",
  "Nu": "VoiceActivityCard.module__participantsRow___bXdhb1",
  "i1": "VoiceActivityCard.module__previewContainer___bXdhb1",
  "n": "VoiceActivityCard.module__previewSubmitting___bXdhb1",
  "FC": "VoiceActivityCard.module__previewHoverOverlay___bXdhb1",
  "oz": "VoiceActivityCard.module__previewImage___bXdhb1",
  "nZ": "VoiceActivityCard.module__previewFallback___bXdhb1",
  "Mp": "VoiceActivityCard.module__previewHoverText___bXdhb1",
  "$l": "VoiceActivityCard.module__actionRow___bXdhb1",
  "hP": "VoiceActivityCard.module__actionButton___bXdhb1",
};

module.exports = exports;
